import React from "react";
import { markdownToHtml, } from "../../utils/markupUtils";
import { generateUUID, getExtension, isVideo, dataURItoBlob } from "../../utils/utils";
import FontAwesome from "react-fontawesome";
import autoBind from "react-autobind";
import { branch } from "baobab-react/higher-order";

// import globals from "../../constants/env";
// import * as s3Actions from "../../persistence/s3";
// import { showError, showYesNo } from "../../actions/alertActions";
// import { waitForKeyExists } from "../../persistence/s3";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
import {
	Dropdown,
	MenuItem
} from "react-bootstrap";
import ambifi from "../../ambifi";
import { showError } from "../../actions/alertActions";
import CameraModal from "../camera/cameraModal";

const unsupportedMsg = "Media upload is not supported.";

class PlayerImagePicker extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		this.state = {
			showMediaLoader: false,
			value: this.props.item.value,
			valueUrls: this.props.item.valueUrls,
			showCameraModal: false
		};

		autoBind(this);
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.state.value, this.state.valueUrls); }
	}

	showHideCameraModal(show) {
		this.setState({
			showCameraModal: show
		});
	}

	onCameraAccept(event) {
		console.log("Accept event: ", event);

		const self = this;
		this.showHideCameraModal(false);

		let fileData;
		let fileName;
		let fileType;
		if (event.type === "video") {
			fileType = "video/mp4";
			fileData = event.blob;
			fileName = "video-capture-" + generateUUID() + ".mp4";
		} else {
			fileType = "image/png";
			fileData = dataURItoBlob(event.data, fileType);
			fileName = "screeshot-" + generateUUID() + ".png";
		}

		this.showMediaLoader();

		this.importMediaFile({
			fileName: fileName,
			fileType: fileType,
			fileData: fileData
		}).then(({ value, valueUrl }) => {
			self.onUploadSuccess(value, valueUrl);
		});
	}

	uploadFile(event) {
		const self = this;
		if (event.target && event.target.files && event.target.files.length === 0) {
			return;
		}

		let file = event.target.files[0];

		this.showMediaLoader();

		this.importMediaFile({
			fileName: file.name,
			fileSize: file.size,
			fileType: file.type,
			fileData: file
		}).then(({ value, valueUrl }) => {
			self.onUploadSuccess(value, valueUrl);
		});
	}

	onUploadSuccess(value, valueUrl) {
		let self = this;
		let { item } = this.props;

		console.log("Image picker file uploaded to: " + valueUrl);
		const newValueUrls = (item.valueUrls) ? item.valueUrls.concat([valueUrl]) : [valueUrl];
		const newValue = (item.value) ? item.value.concat([value]) : [value];

		self.setState({
			value: newValue,
			valueUrls: newValueUrls
		});

		//TODO: Need to figure out how to add value
		if (self.props.onChange) { self.props.onChange(newValue, newValueUrls); }
	};

	showMediaLoader() {
		this.setState({ showMediaLoader: true });
	}

	hideMediaLoader() {
		this.setState({ showMediaLoader: false });
	}

	importMediaFile(params) {
		//console.log("PARAMS", params);
		const self = this;
		return new Promise((resolve, reject) => {
			let fileName = generateUUID();

			let ext = getExtension(params.fileName);
			// let newExt;

			const targetType = isVideo(params.fileName) ? "video" : "image";

			let value = {
				fileName: params.fileName,
				fileSize: params.size,
				fileType: params.type,
				uploaded: true,
				imageId: fileName
			};
			console.log("Handling upload", value, ext, targetType);

			ambifi.persistenceManager.uploadMediaFile(params.fileData, fileName + "." + ext, targetType, this.props.identityId).then((res) => {
				self.hideMediaLoader();
				resolve({ value, valueUrl: res.url });
			}).catch((err) => {
				self.hideMediaLoader();
				reject(err);
				showError("Upload Media Asset", "Failed to upload media asset, please make sure you have proper connectivity.");
			});
		});
	}

	renderReadOnly() {
		const item = this.props.item;

		let component;
		try {
			let imgUrls = "";

			let valueUrls = item.valueUrls ? item.valueUrls : [];

			for (let i = 0; i < valueUrls.length; i++) {
				// Need to loop through all values
				let imgUrlParts = valueUrls[i].split(".");
				let ext = imgUrlParts[imgUrlParts.length - 1];
				let imgUrl;
				if (ext === "mp4" || ext === "mov" || ext === "avi") {
					imgUrl = "<p><b>Video Thumbnail</b><br/><a href='" + valueUrls[i].replace("." + ext, ".mp4") + "' target='blank'><img src='" + valueUrls[i].replace("." + ext, "-00001.png") + "' /></a></p>";
				} else {
					imgUrl = "<p><b>Photo</b><br/><a href='" + valueUrls[i] + "' target='blank'><img style='width: 50%' src='" + valueUrls[i] + "' /></a></p>";
				}

				imgUrls = imgUrls + imgUrl;
			}

			const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
			component =
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					<div style={{ width: "100%", overflowX: "auto" }}>
						<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
						<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
						<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(imgUrls)} />
					</div>
				</div>;

		} catch (e) {
			component =
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					(No Media)
				</div>;
		}
		return component;
	}

	handleClickUpload(id) {
		document.getElementById(id).click();
	}

	renderEditable() {
		const { item, listIndex, sectionIndex, itemIndex, disabled, persistenceType } = this.props;

		let component;

		let loadingDiv;
		let uploadButton;

		if (this.state.showMediaLoader) {
			loadingDiv = <div style={{ margin: "15px" }}><FontAwesome
				name='spinner'
				spin /> Uploading media asset...</div>;
		}

		try {
			let imgUrls = "";

			let valueUrls = item.valueUrls ? item.valueUrls : [];

			for (let i = 0; i < valueUrls.length; i++) {
				// Need to loop through all values
				let imgUrlParts = valueUrls[i].split(".");
				let ext = imgUrlParts[imgUrlParts.length - 1];
				let imgUrl;
				if (ext === "mp4" || ext === "mov" || ext === "avi") {
					imgUrl = "<p><b>Video Thumbnail</b><br/><a href='" + valueUrls[i].replace("." + ext, ".mp4") + "' target='blank'><img src='" + valueUrls[i].replace("." + ext, "-00001.png") + "' /></a></p>";
				} else {
					imgUrl = "<p><b>Photo</b><br/><a href='" + valueUrls[i] + "' target='blank'><img style='width: 50%' src='" + valueUrls[i] + "' /></a></p>";
				}

				imgUrls = imgUrls + imgUrl;
			}

			let cameraMode;
			let showCameraModeSelector;
			let accept;

			switch (item.imagePickerMediaType) {
				case "photo":
					cameraMode = "image";
					accept = "image/*";
					showCameraModeSelector = false;
					break;
				case "video":
					cameraMode = "video";
					accept = "video/*";
					showCameraModeSelector = false;
					break;
				default:
					cameraMode = "image";
					accept = "image/*,video/*";
					showCameraModeSelector = true;
					break;
			}
			console.log(cameraMode, showCameraModeSelector);
			console.log("Render media upload", accept, item);
			let cameraModal = <CameraModal isOpen={this.state.showCameraModal} onClose={(e) => this.showHideCameraModal(false)}
				onAccept={this.onCameraAccept} title={item.imagePickerAddMediaButton} mode={cameraMode} showModeSelector={showCameraModeSelector} />;

			if (persistenceType !== "default") {
				uploadButton = <Dropdown disabled={this.state.showMediaLoader || disabled}>
					<Dropdown.Toggle>
						{item.imagePickerAddMediaButton}
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<MenuItem eventKey="1" onClick={(e) => { this.showHideCameraModal(true) }}>
							<label style={{ fontWeight: "normal" }}>
								<FontAwesome name="camera" /> {item.imagePickerCaptureMediaTitle}
							</label>
						</MenuItem>
						<MenuItem eventKey="2" onClick={() => { this.handleClickUpload("image" + item.guid); }}>
							<label style={{ fontWeight: "normal", width: "100%" }} onChange={this.uploadFile}>
								<FontAwesome name="upload" /> {item.imagePickerUploadTitle ? item.imagePickerUploadTitle : "Upload File..."}<input key={"image" + item.guid} type="file" accept={accept} id={"image" + item.guid} style={{ display: "none" }} onClick={(e) => e.stopPropagation()} />
							</label>
						</MenuItem>
					</Dropdown.Menu>
				</Dropdown>
			} else {
				uploadButton = <div>{unsupportedMsg}</div>;
			}

			const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
			component =
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					<div style={{ width: "100%", overflow: "visible" }}>
						<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
						<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
						<div dangerouslySetInnerHTML={markdownToHtml(imgUrls)} />
						{loadingDiv}
						<div style={{ marginBottom: "12px" }}>
							{uploadButton}
						</div>
						{!disabled && <DoneButton disabled={this.state.showMediaLoader} onSubmit={this.onSubmit} />}
					</div>
					{cameraModal}
				</div>;

		} catch (e) {
			console.warn(e);

			if (persistenceType !== "default") {
				uploadButton = <Dropdown disabled={this.state.showMediaLoader || disabled}>
					<Dropdown.Toggle>
						{item.imagePickerAddMediaButton}
					</Dropdown.Toggle>
					<Dropdown.Menu>
						<MenuItem eventKey="1" onClick={(e) => { this.showHideCameraModal(true) }}>
							<label style={{ fontWeight: "normal" }} onChange={this.uploadFile}>
								<FontAwesome name="camera" /> {item.imagePickerCaptureMediaTitle}
							</label>
						</MenuItem>
						<MenuItem eventKey="2" onClick={() => { this.handleClickUpload("image" + item.guid); }}>
							<label style={{ fontWeight: "normal" }} onChange={this.uploadFile}>
								<FontAwesome name="upload" /> {item.imagePickerUploadTitle ? item.imagePickerUploadTitle : "Upload File..."}<input key={"image" + item.guid} type="file" accept="image/*,video/*" id={"image" + item.guid} style={{ display: "none" }} onClick={(e) => e.stopPropagation()} />
							</label>
						</MenuItem>
					</Dropdown.Menu>
				</Dropdown>
			} else {
				uploadButton = <div>{unsupportedMsg}</div>;
			}

			component =
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					<div style={{ width: "100%", overflowX: "auto" }}>
						<div>(No Media)</div>
						{loadingDiv}
						<div style={{ marginBottom: "12px" }}>
							{uploadButton}
						</div>
						{!disabled && <DoneButton disabled={this.state.showMediaLoader} onSubmit={this.onSubmit} />}
					</div>
				</div>;
		}
		return component;
	}
}

export default branch({
	persistenceType: ["appState", "targetConfig", "type"]
}, withPlayerItemHoc(PlayerImagePicker));